import { createFileRoute, redirect } from '@tanstack/react-router'
import DeeplinkValidation from '@/features/deeplink-validation/DeeplinkValidation'
import { deeplinkConfigs } from '@/features/deeplink-validation/DeeplinkValidation.constants'
import { routes } from '@/routing/routes'

export const Route = createFileRoute('/_main/$product/$protocol')({
  component: DeeplinkValidation,
  validateSearch: (search): { data: string } => ({
    data: (search.data as string) ?? '',
  }),
  beforeLoad: ({ params }) => {
    const { product, protocol } = params
    const deeplinkConfig = deeplinkConfigs.get(`${product}/${protocol}`)

    if (!deeplinkConfig) {
      redirect(routes.InvalidLinkError)
    }
  },
})
